export const PRIVACY_POLICY = "Политика конфиденциальности";
